module.exports = __webpack_public_path__ + "img/phone-light.97a57a14.svg";